import { Base } from './base.model';

export class ComponentContent extends Base {
  name: string;
  version: number;
  description: string;
  html: string;
}
